export default {
  DATE_TIME_FORMATS: {
    MOMENT_PRETTY_TIME: 'ddd, MMM Do YYYY [at] h:mm A',
    MOMENT_LOG_TIME: 'YYYY-MM-DD HH:mm',
    FLATPICKR_FORMAT: 'Y-m-d H:i',
  },
};
